import { enqueueToast } from './toast-store.js';
export const toast = {
    success: (message) => {
        enqueueToast('success', message);
    },
    error: (message) => {
        enqueueToast('error', message);
    },
    info: (message) => {
        enqueueToast('info', message);
    },
};
//# sourceMappingURL=toast.js.map